import React from 'react';
import { FileText, Plus } from 'lucide-react';

export default function CarteiraPage() {
  const estruturacaoData = [
    {
      id: 1,
      nome: 'Carteira Premium Alpha',
      cliente: 'Silva & Associados',
      valorFace: 2800000,
      quantidadeProcessos: 34,
      rentabilidade: 32.5,
      status: 'em_andamento',
      prazo: '45 dias',
      progresso: 65
    },
    {
      id: 2,
      nome: 'Carteira Balanced Beta',
      cliente: 'Oliveira Advogados',
      valorFace: 1750000,
      quantidadeProcessos: 22,
      rentabilidade: 28.7,
      status: 'aprovado',
      prazo: '30 dias',
      progresso: 100
    },
    {
      id: 3,
      nome: 'Carteira Growth Gamma',
      cliente: 'Santos & Partners',
      valorFace: 950000,
      quantidadeProcessos: 15,
      rentabilidade: 41.2,
      status: 'em_andamento',
      prazo: '60 dias',
      progresso: 40
    }
  ];


  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Carteira</h1>
          <p className="text-gray-600">Gerencie carteiras e estruturação de fundos</p>
        </div>
        <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2">
          <Plus className="w-4 h-4" />
          Nova Carteira
        </button>
      </div>

      <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
        <div className="p-6">
          <div className="space-y-4">
            {estruturacaoData.map((item) => (
              <div key={item.id} className="bg-white border border-gray-200 rounded-xl p-6 group relative overflow-hidden transition-all duration-300 hover:shadow-md shadow-sm">
                <div className="flex items-center justify-between">
                  {/* Left Section - Basic Info */}
                  <div className="flex items-center gap-6">
                    <div className="p-3 rounded-xl shadow-lg flex-shrink-0 bg-gradient-to-br from-blue-500 to-blue-600">
                      <FileText className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <h4 className="text-xl font-bold text-gray-900">{item.nome}</h4>
                      <p className="text-sm text-gray-600 font-medium">{item.cliente}</p>
                    </div>
                  </div>

                  {/* Center Section - Metrics */}
                  <div className="flex items-center gap-8">
                    <div className="text-center">
                      <p className="text-xs text-gray-600 font-medium">VALOR DE FACE</p>
                      <p className="text-sm font-bold text-gray-900">
                        R$ {(item.valorFace / 1000000).toFixed(1)}M
                      </p>
                    </div>
                    
                    <div className="text-center">
                      <p className="text-xs text-gray-600 font-medium">PROCESSOS</p>
                      <p className="text-sm font-bold text-gray-900">
                        {item.quantidadeProcessos}
                      </p>
                    </div>

                    <div className="text-center">
                      <p className="text-xs text-gray-600 font-medium">RENTABILIDADE</p>
                      <p className="text-sm font-bold text-green-600">
                        {item.rentabilidade}%
                      </p>
                    </div>

                    <div className="text-center">
                      <p className="text-xs text-gray-600 font-medium">PROGRESSO</p>
                      <p className="text-sm font-bold text-blue-600">
                        {item.progresso}%
                      </p>
                    </div>
                  </div>

                  {/* Right Section - Action */}
                  <div className="flex items-center">
                    <button className="px-4 py-2 bg-gray-100 text-gray-900 border border-gray-300 rounded-lg font-semibold text-sm transition-all duration-300 hover:bg-gray-200 hover:border-gray-400">
                      Ver Detalhes
                    </button>
                  </div>
                </div>
                
                {/* Progress Bar */}
                <div className="mt-4">
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div
                      className="bg-blue-500 h-2 rounded-full transition-all duration-1000"
                      style={{ width: `${item.progresso}%` }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}